import { defineComponent as d, computed as o, openBlock as i, createElementBlock as c, createElementVNode as e, toDisplayString as n, createCommentVNode as _, normalizeStyle as f } from "vue";
const h = ["viewBox"], u = /* @__PURE__ */ e("mask", { id: "fed6b2ed-5a71-42e9-ab13-5c1a6ce41dfd" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#fed6b2ed-5a71-42e9-ab13-5c1a6ce41dfd)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M167 0h178l25.9 252.3L345 512H167l-29.8-253.4z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#6da544",
  d: "M0 0h167v512H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M345 0h167v512H345z"
}, null, -1), x = { fill: "none" }, w = ["r"], B = /* @__PURE__ */ d({
  __name: "it",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(a) {
    const t = a, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), r = o(() => 256 + t.strokeWidth / 2);
    return (y, W) => (i(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      u,
      e("g", m, [
        t.flagName ? (i(), c("title", k, n(t.flagName), 1)) : _("", !0),
        p,
        v,
        g
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: f({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, h));
  }
});
export {
  B as default
};
//# sourceMappingURL=it-664722ea.js.map
